module.exports = __webpack_public_path__ + "static/pic5-e704832ea1b347a3066ff8b8199b82ef.jpg";